import { getStructures } from '../../2.x/iiif/structural';

var getItems = function getItems(resource) {
  return resource.items || [];
};

var getAnnotations = function getAnnotations(resource) {
  return resource.annotations || [];
};

export { getItems, getStructures, getAnnotations };